import { motion } from "framer-motion";
import usePreferStaticUI from "@/lib/usePreferStaticUI";

const ORB_SETS = {
  hero: [
    { className: "top-[-8%] right-[5%] w-[28rem] h-[28rem] bg-roseMilk/50", dx: 18, dy: -12, dur: 22 },
    { className: "bottom-[5%] left-[-6%] w-[22rem] h-[22rem] bg-lavenderFog/45", dx: -14, dy: 10, dur: 26 },
    { className: "top-[40%] right-[-10%] w-[18rem] h-[18rem] bg-sageMint/35", dx: 10, dy: 8, dur: 19 },
  ],
  mission: [
    { className: "top-[-20%] left-[20%] w-[20rem] h-[20rem] bg-roseMilk/40", dx: 8, dy: 6, dur: 24 },
    { className: "bottom-[-15%] right-[10%] w-[16rem] h-[16rem] bg-lavenderFog/35", dx: -10, dy: -8, dur: 20 },
  ],
  trust: [
    { className: "top-[10%] left-[5%] w-[14rem] h-[14rem] bg-butterCream/40", dx: 6, dy: 5, dur: 18 },
    { className: "bottom-[8%] right-[8%] w-[18rem] h-[18rem] bg-skyMist/35", dx: -8, dy: 6, dur: 21 },
  ],
  newsletter: [
    { className: "top-[-12%] right-[15%] w-[24rem] h-[24rem] bg-lavenderFog/40", dx: 12, dy: -6, dur: 23 },
    { className: "bottom-[-8%] left-[10%] w-[20rem] h-[20rem] bg-roseMilk/35", dx: -8, dy: 10, dur: 25 },
  ],
  page: [
    { className: "top-[-5%] right-[0%] w-[16rem] h-[16rem] bg-roseMilk/30", dx: 6, dy: -4, dur: 20 },
    { className: "bottom-[0%] left-[-4%] w-[14rem] h-[14rem] bg-lavenderFog/28", dx: -5, dy: 6, dur: 22 },
  ],
  global: [
    { className: "top-[-12%] right-[6%] w-[22rem] h-[22rem] bg-roseMilk/16", dx: 10, dy: -6, dur: 24 },
    { className: "top-[8%] left-[-10%] w-[20rem] h-[20rem] bg-lavenderFog/14", dx: -8, dy: 5, dur: 28 },
    { className: "top-[25%] right-[25%] w-[16rem] h-[16rem] bg-sageMint/10", dx: 6, dy: 4, dur: 22 },
    { className: "bottom-[-5%] left-[35%] w-[18rem] h-[18rem] bg-butterCream/12", dx: -5, dy: -4, dur: 26 },
  ],
};

/**
 * Slow-drifting vapor / smoke orbs — layered pastel mist.
 */
export const VaporOrbs = ({ variant = "hero", className = "" }) => {
  const reduced = usePreferStaticUI();
  const orbs = ORB_SETS[variant] || ORB_SETS.hero;

  if (reduced) return null;

  return (
    <div className={`absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      {orbs.map((orb, i) => (
        <motion.div
          key={i}
          className={`absolute rounded-full blur-3xl pointer-events-none ${orb.className}`}
          animate={{
            x: [0, orb.dx, -orb.dx * 0.5, 0],
            y: [0, orb.dy, -orb.dy * 0.6, 0],
            scale: [1, 1.06, 0.96, 1],
          }}
          transition={{
            duration: orb.dur,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
      ))}
    </div>
  );
};

export default VaporOrbs;
